import React from "react";
import { Text } from "react-native";
import { store } from "@store";

const hindi = require("./package/hi.json");
const english = require("./package/en.json");

const LOCAL = {
  blank: "",
  hi: hindi,
  en: english,
};

export const t = (key, obj = {}, seperator = "$") => {
  // `?.` on store too: during circular module init (webpack's eval order on
  // web), `t()` can run before @store finishes creating the store. Guarding
  // store keeps it safe (falls back to "hi"); no-op on native where store is
  // always defined by call time.
  let lang = store?.getState()?.auth?.user?.language;
  const tagContainer =
    typeof obj.tagContainer !== "undefined" ? obj.tagContainer : "";
  if (typeof lang !== "string") {
    lang = "hi";
  }
  const path = key.split("/");
  let str = LOCAL[lang];
  while (typeof str !== "string" && path.length !== 0) {
    if (typeof str === "undefined") {
      return LOCAL.blank;
    }
    str = str[path[0]];
    path.shift();
  }
  if (typeof str !== "string") {
    str = LOCAL.blank;
  }
  if (Object.keys(obj).length === 0 || str === LOCAL.blank) {
    return str;
  }
  Object.keys(obj).forEach((objKey) => {
    if (objKey === tagContainer) {
      return;
    }
    str = str.replace(
      new RegExp(`\\${seperator}\\${seperator}${objKey}`, "g"),
      obj[objKey],
    );
  });
  if (tagContainer === "") {
    return str;
  }
  const tagObj = obj[tagContainer];
  str = str.split(" ");
  let customText = "";
  const customRender = [];
  str.forEach((val) => {
    if (
      typeof tagObj[`${val.replaceAll(`${seperator}`, "")}`] === "undefined"
    ) {
      customText += `${val} `;
      return;
    }
    if (customText !== "" || customText !== " ") {
      customRender.push(<Text>{customText}</Text>);

      customText = " ";
    }
    customRender.push(tagObj[`${val.replaceAll(`${seperator}`, "")}`]);
  });
  if (customText !== " ") {
    customRender.push(<Text>{customText}</Text>);
  }
  return customRender;
};

export default t;
